import { render, staticRenderFns } from "./faq_zoom.vue?vue&type=template&id=4dfa29c2&"
import script from "./faq_zoom.vue?vue&type=script&lang=js&"
export * from "./faq_zoom.vue?vue&type=script&lang=js&"
import style0 from "./faq_zoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports